import React from "react";
import ScrollReveal from "./ScrollReveal/ScrollReveal";
import KineticText from "./KineticText";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const certificates = [
  {
    title: "ISO 9001",
    image:
      "https://surfacingstandards.co.uk/wp-content/uploads/2020/01/ISO-9001-2015-logo-1-1000x1000-1.png",
    link: "https://drive.google.com/file/d/12VTYMuFDjSpBBNAEjgFQY1R8LzXiHyoJ/view?usp=sharing",
  },
  {
    title: "ISO 14001",
    image:
      "https://cdnmedia.eurofins.com/corporate-eurofins/media/12152066/iso14001.jpg?width=360&height=336",
    link: "https://drive.google.com/file/d/1l3MCcyoYlJCXZdiCDDhsZ_miG_HJ5JIG/view?usp=sharing",
  },
];

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 800,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};

const Certificates = () => {
  return (
    <section className="py-12 bg-gray-50" aria-label="Our Certifications">
      <ScrollReveal className="max-w-7xl mx-auto px-4 text-center">
        <KineticText as="h6" splitBy="char" className="text-2xl md:text-3xl font-bold text-gray-800 mb-8 heading-font">
          Certifications
        </KineticText>
        <div className="flex gap-10 justify-center">
          {certificates.map((cert, index) => (
            <div key={index} className="px-2">
              <a
                href={cert.link}
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-white hover:bg-gray-100 transition rounded-lg p-4 flex flex-col items-center shadow-sm"
              >
                <img
                  src={cert.image}
                  alt={`${cert.title} - Flormar Bangladesh Certification`}
                  loading="lazy"
                  className="h-48 w-auto object-contain mb-2"
                />
                <p className="text-sm font-bold text-gray-700">{cert.title}</p>
              </a>
            </div>
          ))}
        </div>
      </ScrollReveal>
    </section>
  );
};

export default Certificates;
